/* eslint-disable @typescript-eslint/no-explicit-any */
import { useDispatch } from "react-redux";
import { setConciliationEmailsFilter } from "../index";

export const useConciliationEmailsFilterActions = () => {
  const dispatch = useDispatch();
  const updateFilter: any = ({ key, value }: { key: string; value: any }) =>
    dispatch(setConciliationEmailsFilter({ key, value }));

  const clearAllFilters = () => {
    dispatch(setConciliationEmailsFilter({ key: "storeCode", value: "" }));
    dispatch(setConciliationEmailsFilter({ key: "regional", value: "" }));
    dispatch(setConciliationEmailsFilter({ key: "operator", value: "" }));
    dispatch(setConciliationEmailsFilter({ key: "sent_at", value: "" }));
    dispatch(setConciliationEmailsFilter({ key: "storeAllowedToReceiveEmails", value: false }));
    dispatch(setConciliationEmailsFilter({ key: "date", value: "" }));
    dispatch(setConciliationEmailsFilter({ key: "type", value: "" }));
    dispatch(setConciliationEmailsFilter({ key: "is_finalized", value: false }));
    dispatch(setConciliationEmailsFilter({ key: "status", value: "" }));
    dispatch(setConciliationEmailsFilter({ key: "aggregatedStatus", value: "" }));
    dispatch(setConciliationEmailsFilter({ key: "from_date", value: "" }));
    dispatch(setConciliationEmailsFilter({ key: "to_date", value: "" }));
    dispatch(setConciliationEmailsFilter({ key: "responsible", value: "" }));
    dispatch(setConciliationEmailsFilter({ key: "dateType", value: "" }));
  };

  return { updateFilter, clearAllFilters };
};
